import { AdvisingAbnormalItemFileBase64Bean } from './advising-abnormal-item-file-base64-bean';
import { AdvisingAbnormalOperationUserBean } from './advising-abnormal-operation-user-bean';
export class AdvisingAbnormalDialogAbnormalItemFileUpdateRequest extends AdvisingAbnormalOperationUserBean {
  abnormalItemSeqNo: number;
  newFiles: AdvisingAbnormalItemFileBase64Bean[];
  deletedAbnormalItemFileDocIds: string[];

  constructor() {
    super();
    this.abnormalItemSeqNo = -1;
    this.newFiles = [];
    this.deletedAbnormalItemFileDocIds = [];
  }
}
